module.exports = __webpack_public_path__ + "img/gallery04.ce1b088c.jpg";